// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import NativeInput from "@werner/App/Components/XngExpirationDatePicker/Inputs/NativeInput";
import { baseClassName } from "@werner/App/Components/XngExpirationDatePicker/utils/constants";
import { getInputWidth, validateYear } from "@werner/App/Components/XngExpirationDatePicker/utils/helpers";
import { CommonInputProps, YearFormat } from "@werner/App/Components/XngExpirationDatePicker/utils/types";
import React from "react";

interface OwnProps {
    onChange?: (year: string) => void;
    yearFormat?: YearFormat;
    lastAvailableYear?: number;
}

type YearInputProps = Omit<CommonInputProps, "onChange"> & OwnProps & InjectableCss;

const YearInput: React.FC<YearInputProps> = ({
    onChange,
    value,
    yearFormat = "2-digits",
    className,
    inputRef,
    lastAvailableYear,
    ariaLabel,
    placeholder = "yy",
    ...otherProps
}) => {
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = event => {
        const validatedValue = validateYear(event.target.value, `${value ?? ""}`, yearFormat!, lastAvailableYear);
        onChange?.(validatedValue);
    };

    const inputWidth = getInputWidth(value);
    return (
        <NativeInput
            {...otherProps}
            placeholder={placeholder}
            onChange={handleChange}
            value={value}
            className={`${baseClassName}__inputGroup__year ${className || ""}`}
            ref={inputRef}
            ariaLabel={ariaLabel}
            width={inputWidth}
        />
    );
};

export default YearInput;
